import { DashboardItemResponse, DashboardResponse } from '@/types/service-response'
import { GanttChartData } from '@/model/dashboard/GanttChartData'
import { DashboardMessage } from '@/model/dashboard/DashboardMessage'
import { DailyTableData } from '@/model/dashboard/DailyTableData'
import { PieChartData } from '@/model/dashboard/PieChartData'
import { ColumnChartData } from '@/model/dashboard/ColumnChartData'

export class DashboardData {
  public constructor (
    readonly code: string,
    readonly columnPosition: number,
    readonly rowPosition: number,
    readonly lastUpdatedDate: string,
    readonly widgetId: number,
    readonly widgetName: string,
    readonly widgetData: any,
  ) {}

  static createListFromResponse (responseData: DashboardResponse): Array<DashboardData> {
    return responseData.map((item: DashboardItemResponse) => {
      let widgetData: any = undefined

      if (item.widget_data) {
        if (item.code === 'w_schedule_daily') {
          widgetData = GanttChartData.createListFromResponse(item.widget_data)
        } else if (item.code === 'w_messages') {
          widgetData = DashboardMessage.createListFromResponse(item.widget_data)
        } else if (item.code === 'w_schedule_daily_table') {
          widgetData = DailyTableData.createListFromResponse(item.widget_data)
        } else if (item.code === 'w_capacity_percentage') {
          widgetData = PieChartData.createListFromResponse(item.widget_data)
        } else if (item.code === 'w_capacity_by_employee' || item.code === 'w_bvg_by_employee') {
          widgetData = ColumnChartData.createListFromResponse(item.widget_data)
        } else if (item.code === 'w_schedule_week') {
          widgetData = GanttChartData.createListFromResponse(item.widget_data)
        }
      }

      return new DashboardData(
        item.code,
        item.column_position,
        item.row_position,
        item.data_last_updated_at,
        item.id_widget,
        item.widget_name,
        widgetData
      )
    })
  }
}
